import React from 'react';
import { Outlet } from 'react-router-dom';

const PacientesPage: React.FC = () => {
  return <Outlet />;
};

export default PacientesPage;